module.exports = __webpack_public_path__ + "img/volba-2020.2a95664.png";